import React, { useState } from "react";
import { Modal, message } from "antd";
import DASHBOARD_API from "../../../apis/dashboard.api";
import swal from "sweetalert";

export const ChatDownloadModal = ({
  showDownloadModal,
  setShowDownloadModal,
  selectedUser,
}) => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);
  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };
  const handleSendEmail = async () => {
    if (!email) {
      message.error("Please enter your email address");
      return;
    }
    if (!isValidEmail(email)) {
      message.error("Please enter your Valid email address");
      return;
    }

    // simulate sending email
    setSending(true);
    try {
      // TODO: replace this with your actual API endpoint later
      // await new Promise((resolve) => setTimeout(resolve, 1500));
      let res = await DASHBOARD_API.downloadChat({
        conversationId: selectedUser && selectedUser.id,
        email: email,
      });
      if(res && res.status===200){
        // message.success("Email sent! Check your inbox to continue setup.");
        swal("Success", res.message, "success");
      }

      setShowDownloadModal(false);
      setEmail("");
    } catch (error) {
      // message.error("Failed to send email. Please try again later.");
      swal("Oops!", "Failed to send email. Please try again later.", "error")
    } finally {
      setShowDownloadModal(false);
      setSending(false);
    }
  };
  return (
    <React.Fragment>
      {/* Email Input Modal */}
      <Modal
        visible={showDownloadModal}
        footer={null}
        closable
        centered
        onCancel={() => setShowDownloadModal(false)}
      >
        <div className="text-center space-y-3">
          <h3 className="modaltitle">Send Chat Transcript via Email</h3>
          <p className="mobile-modal-details">
            Enter your email address below to receive a copy of this chat
            conversation. The transcript will include only messages exchanged
            between you and the selected user.
          </p>
          <div style={{ marginBottom: "8px", marginTop: "8px" }}>
            <h3 className="inputTitle" style={{ textAlign: "left" }}>
              Enter Email <span style={{ color: "red" }}>*</span>
            </h3>
            <input
              className="roleInput"
              placeholder="you@example.com"
              name="email"
              type="email"
              value={email}
              id="email"
              onChange={(e) => {
                e.preventDefault();
                e.persist();
                if (!isValidEmail(e.target.value)) {
                  if (e.target.value === "") {
                    setError(null);
                  } else {
                    setError("Email is invalid");
                  }
                } else {
                  setError(null);
                }
                setEmail(e.target.value);
              }}
            />
            {error && (
              <div
                style={{ color: "red", fontSize: "12px", textAlign: "left" }}
              >
                {error}
              </div>
            )}
          </div>

          <div className="buttonsMain">
            <button
              className="cancelbutton"
              style={{ width: "100%" }}
              onClick={() => setShowDownloadModal(false)}
            >
              Cancel
            </button>
            <button
              className="savebutton"
              style={{
                width: "100%",
                opacity: email ? "1" : "0.3",
                cursor: email ? "pointer" : "not-allowed",
                pointerEvents: email ? "" : "none",
              }}
              onClick={handleSendEmail}
              disabled={sending || !email}
            >
              {sending ? "Sending..." : "Send"}
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
